import { inject, Provider } from '@angular/core';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MsalBroadcastService,
  MsalGuard,
  MsalGuardConfiguration,
  MsalRedirectComponent,
  MsalService
} from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  PublicClientApplication
} from '@azure/msal-browser';
import { ENV_CONFIG, EnvConfig } from '@ottobock/shared/domain';

export function MSALInstanceFactory(): IPublicClientApplication {
  const { authEnv } = inject<EnvConfig>(ENV_CONFIG);

  return new PublicClientApplication({
    auth: {
      clientId: authEnv.msalConfig.auth.clientId,
      authority: authEnv.b2cPolicies.authorities.signUpSignIn.authority,
      redirectUri: authEnv.msalConfig.auth.redirectUri,
      postLogoutRedirectUri: '/',
      knownAuthorities: [authEnv.b2cPolicies.authorityDomain]
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage
    },
    system: {
      allowPlatformBroker: false
    }
  });
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  const { authEnv } = inject<EnvConfig>(ENV_CONFIG);

  return {
    interactionType: InteractionType.Redirect,

    authRequest: {
      scopes: [...authEnv.apiConfig.scopes],
      redirectUri: authEnv.msalConfig.auth.redirectUri
    }
  };
}

export const AUTH_PROVIDERS: Provider[] = [
  MsalGuard,
  MsalRedirectComponent,
  MsalBroadcastService,
  MsalService,
  {
    provide: MSAL_GUARD_CONFIG,
    useFactory: MSALGuardConfigFactory
  },
  {
    provide: MSAL_INSTANCE,
    useFactory: MSALInstanceFactory
  }
];
